export default __webpack_public_path__ + "static/media/Twitter_white.3e792238.svg";